module.exports = __webpack_public_path__ + "img/earth-now.e823448f.png";